import { makeStyles } from '@material-ui/styles';

import { neutral } from 'shared/styles/colors';
import { ELEVATED } from 'shared/styles/shadows';

export default makeStyles({
  results: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    zIndex: 10,
    overflowY: 'auto',
    // double the height of the item to allow for scrolling
    maxHeight: '8rem',
    border: `1px solid ${neutral[20]}`,
    borderTop: 'none',
    borderBottomLeftRadius: '0.5rem',
    borderBottomRightRadius: '0.5rem',
    backgroundColor: neutral.white,
    boxShadow: ELEVATED.strong,
  },
  // height of item: 4rem
  item: {
    padding: '0.75rem 1rem',
    cursor: 'pointer',
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
    backgroundColor: neutral.white,
    '&:hover': {
      backgroundColor: neutral[10],
    },
    '&[data-is-selectable="false"]': {
      cursor: 'not-allowed',
    },
  },
  image: {
    color: neutral[40],
    borderRadius: '0.25rem',
    backgroundColor: neutral[10],
    border: `1px solid ${neutral[20]}`,
  },
  content: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    color: neutral[100],
  },
  name: {
    fontWeight: 500,
  },
  price: {
    fontWeight: 'normal',
    color: neutral[60],
  },
});
